import React, { useEffect, useState } from "react";

const Health = (props) => {
  const [stars, setStars] = useState([]);
  const { health, data, wins } = props.player;

  useEffect(() => {
    getStars();
  }, [wins]);

  const getStars = () => {
    let stars = [];
    for (let x = 0; x < wins; x++) {
      stars.push(<i key={x} className={`star-size fas fa-star ${props.status === "p2" ? "mr-1" : "ml-1"}`} />);
    }
    setStars(stars);
    return stars;
  };

  return (
    <div className={`w-100 d-flex ${props.status === "p2" ? "flex-row-reverse" : ""}`}>
      <div className={`health-thumb mx-4 ${health < 30 ? "shake-once" : ""}`}>
        <img
          className={`w-100 rounded border border-light ${props.status === "p2" ? "player-2" : ""} `}
          src={data.thumb}
          alt=""
        />
      </div>
      <div className="flex-1">
        <div className={props.status === "p2" ? "player-2" : ""}>
          <div className={`health ${health < 30 ? "shake-once" : ""}`}>
            <div
              className={`energy ${health < 50 ? (health < 30 ? "bg-danger" : "bg-warning") : ""}`}
              style={{ width: health + "%" }}
            />
            <div className="gradient" />
          </div>
        </div>
        <div
          className={`d-flex flex-wrap align-items-center w-100 ${
            props.status === "p2" && "flex-row-reverse"
          }`}
          >
          <h6 className="m-0" style={{ fontFamily: "mk4" }}>
            {data.name}
          </h6>
          {stars.map((star) => star)}
        </div>
      </div>
    </div>
  );
};

export default Health;
